import styled from '@emotion/styled';

export default styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    paddingRight: '1rem'
});
